import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { LogoLockup } from "./LogoLockup";

export function Footer() {
  const { t, path } = useLang();

  return (
    <footer className="border-t border-borderline bg-paper pt-16 md:pt-24 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 pb-10 border-b border-borderline">
          <p className="font-body text-sm text-secondary max-w-xs">{t.footer.tagline}</p>
          <div className="flex flex-wrap items-center gap-6">
            <Link
              to={path("privacy")}
              data-testid="footer-privacy-link"
              className="font-body font-semibold text-xs uppercase tracking-[0.2em] text-secondary hover:text-ink transition-colors duration-300"
            >
              {t.footer.privacy}
            </Link>
            <a
              href={`mailto:${t.footer.email}`}
              data-testid="footer-email-link"
              className="font-body font-semibold text-xs uppercase tracking-[0.2em] text-secondary hover:text-ink transition-colors duration-300"
            >
              {t.footer.email}
            </a>
          </div>
        </div>
        <div className="pt-14 md:pt-16">
          <LogoLockup variant="primary" size="lg" />
        </div>
        <p className="mt-10 font-body font-semibold text-xs uppercase tracking-[0.2em] text-muted" data-testid="footer-copyright">
          {t.footer.rights}
        </p>
      </div>
    </footer>
  );
}
